import React, { useEffect, useRef, useState } from 'react';
import { CAPTION_OPACITY_RANGE } from '@vbee-holding/aivoice-shared-lib';
import NumberInput from './NumberInput';
import { StyledColorField } from './index.style';

const HEX_PATTERN = /^#[0-9a-fA-F]{6}$/;
const HEX_DIGITS = 6;
// Cột control rộng 200: ô màu 40 + hex + phần trăm 64, kèm hai khoảng cách 8.
const HEX_WIDTH = 80;
const HEX_WIDTH_ALONE = 152;
const OPACITY_WIDTH = 64;

// Giữ dấu # ở đầu, chỉ nhận chữ số hex và không quá 6 chữ.
const cleanHex = (raw) =>
  `#${raw.replace(/[^0-9a-fA-F]/g, '').slice(0, HEX_DIGITS)}`;

/**
 * Ô màu mở bảng chọn của trình duyệt, kèm ô gõ mã HEX. Truyền `opacity` thì có
 * thêm ô phần trăm; bỏ trống thì ô HEX chiếm hết chỗ của nó.
 */
const ColorField = ({
  value,
  opacity,
  disabled,
  onChange,
  onOpacityChange,
}) => {
  const [draft, setDraft] = useState(value);
  const swatchRef = useRef(null);
  const commitRef = useRef(onChange);
  commitRef.current = onChange;
  const hasOpacity = opacity !== undefined;

  useEffect(() => setDraft(value), [value]);

  // Bảng chọn màu bắn sự kiện liên tục theo từng bước kéo, còn `change` chỉ
  // bắn một lần khi người dùng chọn xong. React chỉ nối được cái thứ nhất.
  useEffect(() => {
    const swatch = swatchRef.current;
    const handleCommit = (event) =>
      commitRef.current(event.target.value.toUpperCase());
    swatch.addEventListener('change', handleCommit);
    return () => swatch.removeEventListener('change', handleCommit);
  }, []);

  const commitDraft = () => {
    const next = HEX_PATTERN.test(draft) ? draft.toUpperCase() : value;
    setDraft(next);
    if (next !== value) onChange(next);
  };

  // Ô màu chỉ nhận mã đủ 6 chữ, đang gõ dở thì giữ màu cũ.
  const swatchColor = HEX_PATTERN.test(draft) ? draft : value;

  return (
    <StyledColorField $hexWidth={hasOpacity ? HEX_WIDTH : HEX_WIDTH_ALONE}>
      <span
        className="color-field-swatch"
        style={{ backgroundColor: swatchColor }}
      >
        <input
          ref={swatchRef}
          type="color"
          value={swatchColor}
          disabled={disabled}
          onChange={(event) => setDraft(event.target.value.toUpperCase())}
        />
      </span>
      <input
        className="color-field-hex"
        value={draft}
        disabled={disabled}
        onChange={(event) => setDraft(cleanHex(event.target.value))}
        onBlur={commitDraft}
        onKeyDown={(event) => event.key === 'Enter' && event.target.blur()}
      />
      {hasOpacity && (
        <NumberInput
          width={OPACITY_WIDTH}
          value={opacity}
          range={CAPTION_OPACITY_RANGE}
          suffix="%"
          onChange={onOpacityChange}
        />
      )}
    </StyledColorField>
  );
};

export default ColorField;
